import {
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
} from './typography';
import {
  easings,
  durations,
} from './transitions';
import colors from './colors';
import radii from './radii';
import zIndices from './z-indices';
import toCssVars from './to-css-vars';

const cssVars = `
  ${toCssVars('--colors', colors)}
  ${toCssVars('--radii', radii)}
  ${toCssVars('--font-sizes', fontSizes)}
  ${toCssVars('--font-weights', fontWeights)}
  ${toCssVars('--line-heights', lineHeights)}
  ${toCssVars('--letter-spacings', letterSpacings)}
  ${toCssVars('--durations', durations)}
  ${toCssVars('--easings', easings)}
  ${toCssVars('--z-indices', zIndices)}
`;

export default cssVars;
